import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from './SafeIcon';
import BrandMark from './BrandMark';
import { FiGrid, FiClock, FiMapPin, FiPieChart, FiBriefcase, FiSettings, FiPlayCircle, FiHelpCircle } from 'react-icons/fi';

const navItems = [
  { id: 'dashboard', icon: FiGrid, label: 'Overview' },
  { id: 'demo', icon: FiPlayCircle, label: 'Demo' },
  { id: 'timeline', icon: FiClock, label: 'Timeline' },
  { id: 'places', icon: FiMapPin, label: 'Places' },
  { id: 'budget', icon: FiPieChart, label: 'Budget' },
  { id: 'packing', icon: FiBriefcase, label: 'Packing' },
];

export default function Navigation({ activeTab, setActiveTab }) {
  return (
    <>
      <div className="hidden md:flex flex-col w-64 bg-midnight-800/80 border-r border-white/5 h-screen fixed left-0 top-0 backdrop-blur-2xl z-50">
        <div className="p-8">
          <div className="flex items-center gap-3 group cursor-pointer">
            <BrandMark className="w-10 h-10" />
            <div className="flex flex-col">
              <span className="font-mono text-xl font-black tracking-tighter text-white leading-none">ROUTEMUSE</span>
              <span className="text-[9px] font-mono text-cyan-400/60 tracking-[0.3em] uppercase">Operational Hub</span>
            </div>
          </div>
        </div>
        
        <nav className="flex-1 px-4 py-4 space-y-1.5 overflow-y-auto scrollbar-hide">
          <div className="px-4 py-2 text-[10px] font-mono text-gray-600 tracking-widest uppercase">Navigation Core</div>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 relative group ${
                activeTab === item.id 
                  ? 'bg-cyan-400/10 text-cyan-400 border border-cyan-400/30' 
                  : 'text-gray-500 hover:text-white hover:bg-white/5 border border-transparent'
              }`}
            >
              <SafeIcon icon={item.icon} className={`text-xl transition-transform group-hover:scale-110 ${activeTab === item.id ? 'text-cyan-400' : ''}`} />
              <span className="text-sm font-medium tracking-wide">{item.label}</span>
              {activeTab === item.id && (
                <motion.div layoutId="activeNav" className="absolute left-0 w-1 h-8 bg-cyan-400 rounded-r-md shadow-[0_0_10px_rgba(0,240,255,0.8)]" />
              )}
              {item.id === 'demo' && (
                <span className="absolute right-3 px-1.5 py-0.5 rounded bg-coral-400 text-[9px] font-bold text-white shadow-[0_0_10px_rgba(255,107,107,0.5)] animate-pulse">LIVE</span>
              )}
            </button>
          ))}
        </nav>

        <div className="p-6 border-t border-white/5 space-y-4 bg-black/20">
          <button className="flex items-center gap-3 text-xs text-gray-500 hover:text-white transition-colors w-full group">
            <SafeIcon icon={FiHelpCircle} className="group-hover:text-cyan-400" />
            <span>Support Terminal</span>
          </button>
          <button className="flex items-center gap-3 text-xs text-gray-500 hover:text-white transition-colors w-full group">
            <SafeIcon icon={FiSettings} className="group-hover:text-cyan-400" />
            <span>System Settings</span>
          </button>
          <div className="pt-4 flex flex-col items-center gap-2 border-t border-white/5">
            <BrandMark className="w-6 h-6 opacity-40" color="#666" />
            <div className="text-[9px] text-gray-700 font-mono text-center leading-relaxed uppercase tracking-widest">
              Made by LingLink AI<br/>and DigLab AI
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden fixed bottom-0 left-0 right-0 glass-card rounded-none rounded-t-2xl border-b-0 border-white/10 z-50 px-4 py-2 flex justify-between items-center pb-safe box-border shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`flex flex-col items-center gap-1 min-w-[50px] p-2 rounded-xl transition-all ${
              activeTab === item.id ? 'text-cyan-400 bg-cyan-400/10' : 'text-gray-500'
            }`}
          >
            <SafeIcon icon={item.icon} className="text-lg" />
            <span className="text-[8px] font-mono uppercase tracking-tighter">{item.label}</span>
          </button>
        ))}
      </div>
    </>
  );
}